export const hasEcwidCart = () => {
  if (window.Ecwid) {
    if (window.Ecwid.Cart) {
      return true;
    }
  }
  return false;
}

export const getCart = () => {
  if (hasEcwidCart()) {
    return window.Ecwid.Cart;
  }
}